// store/UserProvider.js
import React, { createContext, Component } from "react"; // on importe createContext qui servira à la création d'un ou plusieurs contextes

export const ThreeContext = createContext({
  newRadioUrl: "",
  town: "Lyon",
  setOnoff: () => {},
})

/* la classe UserProvider fera office de... Provider (!)
 * en englobant son enfant direct
 * dans le composant éponyme. De cette façon, ses values
 * seront accessibles de manière globale via le `Consumer`
 */
class Context extends Component {
    constructor(props){
        super(props)
        this.state = {
            radios: [],
            location: "off", // une valeur de départ
            town: "Lyon",
            setLocation: location => this.setState({ location: location }) // nouvelle propriété de mutation
        };
    }
    render() {
        return (
          // Ici, rien ne change !
          <ThreeContext.Provider value={this.state}>
            {this.props.children}
          </ThreeContext.Provider>
        );
    }
}

export default Context

